import { pixelsToUnits } from "./helpers";
import { UNIT_TYPES_PREFIX } from "./constant";
import { round } from "lodash";
import * as THREE from "three";

export const binInfo = (inventoryProducts = [] , cube = {}, type = "bin") => {
  if (!cube?.code) {
    console.warn("Invalid cube provided to binInfo");
    return { modalPayload: { BinCode: null, BinInfo: [], BinData: [] } };
  }

  // Filter products once
  const binData = inventoryProducts.filter(
    (p) => p?.doc_location === cube.code
  );

  // Compute total quantity using reduce
  const totalQuantity = binData.reduce(
    (acc, { quantity = 0 }) => acc + quantity,
    0
  );

  // 📏 Precompute converted dimensions
  const unitPrefix = UNIT_TYPES_PREFIX[cube.unitType] || "";
  const binWidth = round(pixelsToUnits(cube.width, cube.unitType), 2);
  const binHeight = round(pixelsToUnits(cube.height, cube.unitType), 2);
  const binDepth = round(pixelsToUnits(cube.depth, cube.unitType), 2);

  // Reusable dimension formatter
  const formatDimensions = (dims) => dims.join(" x ");

  // Info builders
  const infoBuilders = {
    bin: () => [
      { label: "Rack Code", value: cube.rackCode },
      {
        label: `W x H x D (${unitPrefix})`,
        value: formatDimensions([binWidth, binHeight, binDepth]),
      },
      { label: "Quantity", value: totalQuantity },
    ],
    subArea: () => [
      { label: "Area Code", value: cube.code },
      {
        label: `W x D (${unitPrefix})`,
        value: formatDimensions([binWidth, binHeight]),
      },
      { label: "Quantity", value: totalQuantity },
    ],
  };

  // Select proper builder safely
  const BinInfo = (infoBuilders[type] || infoBuilders["bin"])();

  // Final payload
  return {
    modalPayload: {
      BinCode: cube.code,
      BinInfo,
      BinData: binData,
    },
  };
};

export function groupBinsByRows(bins) {
  const tolerance = 2; // or binHeight/2

  const rows = [];

  bins.forEach(bin => {
    const y = bin.positionY;

    // try to find an existing row group
    let row = rows.find(r => Math.abs(r.y - y) < tolerance);

    if (!row) {
      row = { y, bins: [] };
      rows.push(row);
    }

    row.bins.push(bin);
  });

  // Sort rows by Y-axis
  rows.sort((a, b) => a.y - b.y);

  // Sort bins inside each row by X-axis
  rows.forEach(row => {
    row.bins.sort((a, b) => a.positionX - b.positionX);
  });

  return rows;
}

export function darkenColor(hex, percent = 0.25) {
  const color = new THREE.Color(hex);
  const hsl = {};
  color.getHSL(hsl);
  hsl.l *= 1 - percent; // reduce lightness
  return new THREE.Color().setHSL(hsl.h, hsl.s, hsl.l).getStyle();
}